<template>
    <div class="carBox" @mouseup="handleMouseUp">
        <el-card ref="left_tree" class="box-card" style="height: calc(100vh - 152px);width: 280px;overflow-y: auto">
            <el-tree :data="projectDivisionData" node-key="value" :current-node-key="pid" :highlight-current="true" ref="my-tree" @node-click="clickPrjectDivision" :default-expanded-keys="openKeys" :expand-on-click-node="false">
                <span slot-scope="{ node }" class="custom-tree-node treeTitle" :title="node.label.split('###')[3]">
                    {{node.label.split('###')[0]}}
                    <span :class="'treeTitleNum'+node.label.split('###')[1]">{{node.label.split('###')[2]}}</span>
                </span>
            </el-tree>
        </el-card>
        <div ref="resizeHandle" class="handle-resize" />
        <div ref="moveDiv" class="handle-resize-h" />
        <el-card class="box-card" style="width: calc(100% - 344px); padding-top: 25px">
            <div class="tabBox">
                <div :class="'tabItem'+(search_type==1?' act':'')" @click="changeSearchType(1)">按孔查询</div>
                <div :class="'tabItem'+(search_type==2?' act':'')" @click="changeSearchType(2)">按报告查询</div>
            </div>
            <div class="mainBody">
                <div class="searchBox" v-if="list_model ==1">
                    <div class="searchGroup" v-if="search_type==1">
                        <label>灌浆类型：</label>
                        <el-select v-model="search_Obj.f_grout_type" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                            <el-option v-for="item in enuObj('grout_type')" :key="'grout_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                        </el-select>
                    </div>
                    <div class="searchGroup">
                        <label>孔号：</label>
                        <el-input v-model="search_Obj.f_hole_code" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <div class="searchGroup" v-if="search_type==1">
                        <label>加深孔：</label>
                        <el-select v-model="search_Obj.f_is_deepen" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                            <el-option v-for="item in enuObj('yesNo')" :key="'deepen'+item.key" :label="item.title" :value="item.key"> </el-option>
                        </el-select>
                    </div>
                    <div class="searchGroup" v-if="search_type==2">
                        <label>段号：</label>
                        <el-input v-model="search_Obj.f_segment_no" clearable @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                    </div>
                    <div class="searchGroup" v-if="search_type==2">
                        <label>开始时间：</label>
                        <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="dateRangeSet1"
                            style="width:320px">
                        </el-date-picker>
                    </div>
                    <div class="searchGroup" v-if="search_type==2">
                        <label>单位注灰量区间：</label>
                        <el-input v-model="search_Obj.ash_volume_unit_min" clearable :disabled="(search_Obj.permeable_rate_min!='' || search_Obj.permeable_rate_max!='')" @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                        <span style="margin: 0 2px">-</span>
                        <el-input v-model="search_Obj.ash_volume_unit_max" clearable :disabled="(search_Obj.permeable_rate_min!='' || search_Obj.permeable_rate_max!='')" @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                    </div>
                    <div class="searchGroup" v-if="search_type==2">
                        <label>透水率区间：</label>
                        <el-input v-model="search_Obj.permeable_rate_min" clearable :disabled="(search_Obj.ash_volume_unit_min!='' || search_Obj.ash_volume_unit_max!='')" @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                        <span style="margin: 0 2px">-</span>
                        <el-input v-model="search_Obj.permeable_rate_max" clearable :disabled="(search_Obj.ash_volume_unit_min!='' || search_Obj.ash_volume_unit_max!='')" @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                    <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick" v-if="search_type==1"></Btns>
                </div>
                <div class="dataBox" v-if="list_model ==1 && search_type == 1">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column prop="unit_name" label="单元工程" sortable="custom"></el-table-column>
                        <el-table-column prop="unit_code" label="单元编号" sortable="custom" width="150"></el-table-column>
                        <el-table-column prop="hole_code" label="孔号" sortable="custom"></el-table-column>
                        <el-table-column prop="hole_order" label="孔序" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="grout_type" label="灌浆类型" sortable="custom" width="120">
                            <template slot-scope="scope" v-if="search_type==1">
                                <span>{{ transEnu(scope.row.grout_type, "grout_type") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="order_index" label="顺序" sortable="custom" width="100"></el-table-column>
                        <el-table-column label="操作" width="220" align="center">
                            <template slot-scope="scope" v-if="search_type==1">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" :ignore_ids="',5102,'" @on_btnclk="labelClick" v-if="scope.row.annex_count<=0"></LabBtns>
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick" v-else></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="titleBoxwhr" v-if="list_model ==2 && search_type==1">
                    <h3>
                        孔号：{{work_hole.hole_code}}
                    </h3>
                    <el-button style="margin-left: 50px" @click="back()">返回</el-button>
                </div>
                <div class="dataBox" v-if="list_model ==2 && search_type==1">
                    <el-table :data="tableData1" v-loading="loading" border stripe>
                        <el-table-column prop="hole_code" label="孔号" width="220"></el-table-column>
                        <el-table-column prop="segment_no" label="段号" width="120"></el-table-column>
                        <el-table-column prop="report_count" label="报告数量" width="120"></el-table-column>
                        <el-table-column label="操作" align="center">
                            <template slot-scope="scope" v-if="search_type==1">
                                <el-button  size="mini" plain type="primary" @click="infoAll(scope.row)">查看</el-button>
                                <template v-if="qx==1 && search_type==1">
                                    <el-button  size="mini" plain type="primary" @click="infoVerifyCheck(scope.row)" v-if="scope.row.has_verify_check>0">查看监测对比分析</el-button>
                                    <el-button  size="mini" plain type="primary" @click="createJiaoYan(scope.row)" v-else>生成监测对比分析</el-button>
                                    <el-button  size="mini" plain type="primary" @click="infoVerifySpot(scope.row)" v-if="scope.row.has_verify_spot>0">查看记录对比分析</el-button>
                                    <el-button  size="mini" plain type="primary" @click="infoVerifyDiff(scope.row)" v-if="scope.row.has_verify_diff>0">查看抽检对比分析</el-button>
                                    <el-button  size="mini" plain type="primary" @click="createChaYi(scope.row)" v-else>生成抽检对比分析</el-button>
                                </template>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="dataBox" v-if="search_type == 2">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column prop="hole_code" label="孔号" sortable="custom"></el-table-column>
                        <el-table-column prop="segment_no" label="段号" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="work_type_int" label="作业方式" sortable="custom" width="120">
                            <template slot-scope="scope" v-if="search_type == 2">
                                <span>{{ transEnu(scope.row.work_type_int, "work_type_int") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="begin_time" label="开始时间" sortable="custom" width="170"></el-table-column>
                        <el-table-column prop="grout_volume" label="注浆量" sortable="custom" width="170"></el-table-column>
                        <el-table-column prop="ash_volume" label="注灰量" sortable="custom" width="170"></el-table-column>
                        <el-table-column prop="ash_volume_unit" label="单位注灰量" sortable="custom" width="170"></el-table-column>
                        <el-table-column prop="permeable_rate" label="透水率" sortable="custom" width="170"></el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope" v-if="search_type == 2">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" :ignore_ids="',5102,'" @on_btnclk="labelClick"></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox" v-if="list_model ==1 || search_type == 2">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
                <Info
                    :report_type="report_type"
                    :hole_id="hole_id"
                    :segment_no="segment_no"
                    :to_report_id="to_report_id"
                    title="查看作业报告"
                    :isshow="infoshow"
                    @on-close="closeInfoDialog">
                </Info>
                <AnnexList
                    width="600px"
                    :data_id="model_id"
                    :isshow="annexshow"
                    @on-close="closeAnnexDialog">
                </AnnexList>
                <VerifyCheckInfo
                    :hole_id="hole_id"
                    :segment_no="segment_no"
                    title="监测数据验证分析详情"
                    :isshow="verify_check_show"
                    :report_type="2"
                    @on-close="closeVerifyCheckDialog"
                    @on-save-ok="closeVerifyCheckDialog">
                </VerifyCheckInfo>
                <VerifySpotInfo
                    :hole_id="hole_id"
                    :segment_no="segment_no"
                    title="抽检数据对比分析详情"
                    :isshow="verify_spot_show"
                    @on-close="closeVerifySpotDialog"
                    @on-save-ok="closeVerifySpotDialog">
                </VerifySpotInfo>
                <VerifyDiffInfo
                    :hole_id="hole_id"
                    :segment_no="segment_no"
                    title="抽检数据验证分析详情"
                    :isshow="verify_diff_show"
                    :report_type="4"
                    @on-close="closeVerifyDiffDialog"
                    @on-save-ok="closeVerifyDiffDialog">
                </VerifyDiffInfo>
            </div>
        </el-card>
        <el-dialog title="批量导出Excel" :visible.sync="export_show" width="500px">
            <el-checkbox-group v-model="work_type_int">
                <el-checkbox :label="1">灌浆</el-checkbox>
                <el-checkbox :label="2">冲洗</el-checkbox>
                <el-checkbox :label="3">压水</el-checkbox>
                <el-checkbox :label="4">复灌</el-checkbox>
                <el-checkbox :label="5">封孔</el-checkbox>
            </el-checkbox-group>
            <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                @change="dateRangeSet"
                style="width:320px;margin-top: 20px">
            </el-date-picker>
            <div slot="footer" class="dialog-footer">
                <el-button @click="export_show = false">取 消</el-button>
                <el-button type="primary" @click="doExportBatch">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import listutil from "@/libs/listutil"
import { getListData } from '@/api/common'
import { getProjectDivisionTreeData } from '@/api/org'
import { holeReportList, exportWorkReportBatch, checkExportWorkReportBatchCompleted } from '@/api/workreport'
import { createVerifyFromFile } from '@/api/statistic'
import Info from "./info"
import VerifyCheckInfo from "../verify/checkinfo.vue"
import VerifySpotInfo from "../verify/spotinfo.vue"
import VerifyDiffInfo from "../verify/diffinfo.vue"
import AnnexList from "./annexlist"

export default {
    name: 'workreportList',
    mixins: [listutil],
    components: {Info, Btns, LabBtns, AnnexList, VerifyCheckInfo, VerifySpotInfo, VerifyDiffInfo},
    data() {
        return {
            m_name: '灌浆孔-作业报告',
            menu_id: 5100,
            list_url: "/api/admin/workhole/list",
            search_Obj: {
                f_grout_type: '',
                f_hole_code: '',
                f_is_deepen: '',
                report_type: 1,
                f_report_type: 1,
                f_segment_no: '',
                f_state: 1,
                ash_volume_unit_max: '',
                ash_volume_unit_min: '',
                permeable_rate_max: '',
                permeable_rate_min: '',
            },
            del_Obj:{
                url:'/api/admin/workhole/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['grout_type', 'yesNo', 'work_type_int'],
            grade: 1,
            pid: 0,
            projectDivisionData: [],
            openKeys: [],
            sortData: {
                prop: 'order_index',
                order: 'ascending'
            },
            list_model: 1,
            report_type: 1,
            hole_id: 0,
            segment_no: '',
            to_report_id: 0,
            tableData1: [],
            work_hole: {},
            annexshow: false,
            verify_check_show: false,
            verify_spot_show: false,
            verify_diff_show: false,
            qx: 0,
            export_show: false,
            dateRange: '',
            start_date: '',
            end_date: '',
            work_type_int: [],
        };
    },
    mounted(){
        this.dragControllerDiv(this.$refs.left_tree.$el, this.$refs.resizeHandle, this.$refs.moveDiv)
    },
    methods: {
        loadOtherData() {
            this.initTree()
        },
        initTree(){
            this.projectDivisionData = []
            getProjectDivisionTreeData(11).then(res=>{
                if(res.code ==1){
                    var treeData = res.data
                    treeData = this.removeEmptyChild(treeData)
                    this.projectDivisionData = treeData
                    this.initOpenKeys()
                }
            })
        },
        initOpenKeys(){//哪些节点要展开
            this.openKeys = this.getAllNodeId(this.openKeys, this.projectDivisionData, 0)
        },
        getAllNodeId (expandedKeys, moduleDataList, level) {
            if(level>1){
                return expandedKeys
            }
            for (let i = 0; i < moduleDataList.length; i++) {
                expandedKeys.push(moduleDataList[i].value)
                if (moduleDataList[i].children) {
                    expandedKeys = this.getAllNodeId(expandedKeys, moduleDataList[i].children, level+1)
                }
            }
            return expandedKeys
        },
        getListData() {
            this.loading = true;
            this.selectData = [];
            if(this.search_type == 1){
                this.list_url = "/api/admin/workhole/list"
            }else if(this.search_type == 2){
                this.list_url = "/api/admin/workreport/list"
            }
            getListData(this.list_url, this.search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data.resultList;
                    this.total = res.data.totalRecords;
                    this.grade = res.data.grade
                    this.pid = res.data.pid
                    setTimeout(() => {
                        this.$refs["my-tree"].setCurrentKey(this.pid);
                    }, 1000);
                }
            })
        },
        clickPrjectDivision(data){
            this.pid = data.id
            this.search_Obj.pid = data.id
            this.getListData()
            this.list_model = 1
        },
        info(index, row) {
            if(this.search_type == 1){
                this.list_model = 2
                holeReportList(row.id, this.report_type).then(res=>{
                    if(res.code == 1){
                        this.tableData1 = res.data.list
                        this.work_hole = res.data.work_hole
                        this.qx = res.data.qx
                    }
                })
            }else if(this.search_type == 2){
                this.hole_id = row.hole_id
                this.segment_no = row.segment_no
                this.infoshow = true
                this.to_report_id = row.id
            }
        },
        back(){
            this.list_model = 1
            this.tableData1 = []
            this.work_hole = {}
        },
        infoAll(row){
            this.hole_id = row.hole_id
            this.segment_no = row.segment_no
            this.infoshow = true
        },
        downAnnex(index, row){
            this.model_id = row.id
            this.annexshow = true
        },
        closeAnnexDialog(){
            this.annexshow = false
        },
        infoVerifyCheck(row){
            this.hole_id = row.hole_id
            this.segment_no = row.segment_no
            this.verify_check_show = true
        },
        infoVerifySpot(row){
            this.hole_id = row.hole_id
            this.segment_no = row.segment_no
            this.verify_spot_show = true
        },
        infoVerifyDiff(row){
            this.hole_id = row.hole_id
            this.segment_no = row.segment_no
            this.verify_diff_show = true
        },
        closeVerifyCheckDialog(){
            this.verify_check_show = false
        },
        closeVerifySpotDialog(){
            this.verify_spot_show = false
        },
        closeVerifyDiffDialog(){
            this.verify_diff_show = false
        },
        createJiaoYan(row){
            this.hole_id = row.hole_id
            this.segment_no = row.segment_no
            createVerifyFromFile(2, this.hole_id, this.segment_no).then(res=>{
                if(res.code ==1){
                    this.$msgs("生成成功")
                    setTimeout(() => {
                        let hole = {
                            "id": this.hole_id
                        }
                        this.info(1, hole);
                    }, 1000);
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        createChaYi(row){
            this.hole_id = row.hole_id
            this.segment_no = row.segment_no
            createVerifyFromFile(4, this.hole_id, this.segment_no).then(res=>{
                if(res.code ==1){
                    this.$msgs("生成成功")
                    setTimeout(() => {
                        let hole = {
                            "id": this.hole_id
                        }
                        this.info(1, hole);
                    }, 1000);
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        exportExcelBatch(){
            this.export_show = true
        },
        async doExportBatch(){
            const loading = this.$loading({
                lock: true,
                text: '正在导出，该过程用时较长，请耐心等待...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const res = await exportWorkReportBatch(this.pid, this.start_date, this.end_date, this.work_type_int)
            if(res.code == 1){
                const timer = setInterval(async () => {
                    const res1 = await checkExportWorkReportBatchCompleted(res.data);
                    if(res1.code == 1){
                        loading.close()
                        clearInterval(timer);
                        this.export_show = false
                        window.open(res1.data)
                    }else if(res1.code == 0){
                        loading.close()
                        clearInterval(timer);
                        this.$msg(res1.msg)
                    }
                }, 2000);
            }else if(res.code == 990){
                loading.close()
                this.$msg("无数据可导出")
            }else{
                loading.close()
                this.$msg(res.msg)
            }
            
        },
        dateRangeSet(val){
            if(this.$isNotNull(val)){
                this.start_date = val[0]
                this.end_date = val[1]
            }else{
                this.start_date = ''
                this.end_date = ''
            }
        },
        changeSearchType(type){
            this.search_type = type
            this.to_report_id = 0
            this.back()
            this.doSearch()
        },
        dateRangeSet1(val){
            if(this.$isNotNull(val)){
                this.search_Obj.f_begin_time_s_date = val[0]
                this.search_Obj.f_begin_time_e_date = val[1]
            }else{
                this.search_Obj.f_begin_time_s_date = ''
                this.search_Obj.f_begin_time_e_date = ''
            }
        },
    }
};
</script>
<style lang="less" scoped>
    .titleBoxwhr {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
    }
    .carBox .el-card:first-child /deep/ .el-card__body {
        padding: 20px 6px;
    }
</style>